import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as TimelineService from "_services/timeline-service";

export const createBooking = createAsyncThunk(
  "flightScanner/createBooking",
  async (booking) => {
    return TimelineService.postBooking(booking);
  }
);

export const patchBooking = createAsyncThunk(
  "flightScanner/patchBooking",
  async (booking) => {
    return TimelineService.patchBooking(booking);
  }
);

// delete booking
export const deleteBooking = createAsyncThunk('flightScanner/deleteBooking', async (bookings) => {
  return TimelineService.deleteBooking(bookings);
});

const FlightScannerSlice = createSlice({
  name: 'flightScanner',
  initialState: {
    // create
    scannedBooking: null,
    status: 'idle',
    error: null,
    // patch
    patchStatus: 'idle',
    patchError: null,

    // delete
    deleteStatus: 'idle',
    deleteError: null,
  },
  reducers: {
    reset: (state) => {
      state.scannedBooking = null;
      state.status = 'idle';
      state.error = null;
    },
    resetScanFlags: (state) => {
      state.status = 'idle';
      state.error = null;
      state.scannedBooking = null;
      state.patchStatus = 'idle';
      state.patchError = null;
      state.deleteStatus = 'idle';
      state.deleteError = null;
    }
  },
  extraReducers: {
    // create
    [createBooking.pending]: (state, action) => {
      state.status = "loading";
    },
    [createBooking.fulfilled]: (state, action) => {
      state.status = "succeeded";
      state.scannedBooking = action.payload;
    },
    [createBooking.rejected]: (state, action) => {
      state.status = "failed";
      state.error = action.error.message;
    },
    // patch
    [patchBooking.pending]: (state, action) => {
      state.patchStatus = "loading";
      state.patchError = null;
    },
    [patchBooking.fulfilled]: (state, action) => {
      state.patchStatus = "succeeded";
      state.scannedBooking = action.payload;
    },
    [patchBooking.rejected]: (state, action) => {
      state.patchStatus = "failed";
      state.patchError = action.error.message;
    },
    // delete
    [deleteBooking.pending]: (state, action) => {
      state.deleteStatus = "loading";
      state.deleteError = null;
    },
    [deleteBooking.fulfilled]: (state, action) => {
      state.deleteStatus = "succeeded";
    },
    [deleteBooking.rejected]: (state, action) => {
      state.deleteStatus = "failed";
      state.deleteError = action.error.message;
    },
  }
});

export default FlightScannerSlice.reducer;

// delete booking
export const selectDeleteBookingStatus = (state) => state.flightScanner.deleteStatus;
export const selectDeleteBookingError = (state) => state.flightScanner.deleteError;

// create booking
export const selectScannedBooking = (state) => state.flightScanner.scannedBooking;
export const selectScannedBookingError = (state) => state.flightScanner.error;
export const selectScannedBookingStatus = (state) => state.flightScanner.status;

// patch booking
export const selectPatchBookingStatus = (state) => state.flightScanner.patchStatus;
export const selectPatchBookingError = (state) => state.flightScanner.patchError;

export const { reset, resetScanFlags } = FlightScannerSlice.actions;
